<div
  *ngIf="uploadState && uploadState.isActive && uploadState.isMinimized"
  class="upload-minimized"
  (click)="toggleMinimize()"
>
  <div class="minimized-content">
    <div class="minimized-icon">
      <i
        *ngIf="isUploadFullyComplete"
        class="pi pi-check-circle"
        style="color: #ffffff"
      ></i>
      <i *ngIf="!isUploadFullyComplete" class="pi pi-cloud-upload"></i>
    </div>

    <div class="minimized-info">
      <div class="minimized-title">
        {{ isUploadFullyComplete ? "Upload Complete" : "Uploading Files..." }}
      </div>
      <div class="minimized-progress">
        {{ uploadState.successCount }} / {{ uploadState.totalFiles }} completed
      </div>
    </div>

    <div class="minimized-percentage">{{ getOverallProgress() }}%</div>
    <button
      *ngIf="isUploadFullyComplete"
      class="minimized-close-btn"
      (click)="closeMinimizedPopup($event)"
      title="Close"
      type="button"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="minimized-progress-bar">
    <div
      class="minimized-progress-fill"
      [style.width.%]="getOverallProgress()"
      [style.background-color]="isUploadFullyComplete ? '#28a745' : null"
    ></div>
  </div>
</div>

<div
  *ngIf="uploadState && uploadState.isActive && !uploadState.isMinimized"
  class="upload-popup"
>
  <div class="popup-header">
    <div class="popup-title">
      <i class="pi pi-cloud-upload me-2"></i>
      <span>Upload Progress</span>
    </div>
    <div class="popup-actions">
      <button class="btn-icon" (click)="toggleMinimize()" title="Minimize">
        <i class="pi pi-window-minimize"></i>
      </button>
      <button
        class="btn-icon"
        (click)="closePopup()"
        [disabled]="uploadState.pendingCount > 0 || apiCallStatus === 'loading'"
        title="Close"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="popup-body">
    <!-- Overall Progress -->
    <div class="overall-progress mb-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="fw-bold">Overall Progress</span>
        <span class="text-muted">
          {{ uploadState.successCount }} / {{ uploadState.totalFiles }} files
        </span>
      </div>
      <div class="progress" style="height: 12px">
        <div
          class="progress-bar bg-success"
          role="progressbar"
          [style.width.%]="
            (uploadState.successCount / uploadState.totalFiles) * 100
          "
        ></div>
        <div
          class="progress-bar bg-danger"
          role="progressbar"
          [style.width.%]="
            (uploadState.errorCount / uploadState.totalFiles) * 100
          "
        ></div>
      </div>
      <div class="d-flex justify-content-between mt-2">
        <small class="text-success">
          <i class="pi pi-check-circle"></i>
          {{ uploadState.successCount }} Success
        </small>
        <small class="text-danger" *ngIf="uploadState.errorCount > 0">
          <i class="pi pi-times-circle"></i> {{ uploadState.errorCount }} Failed
        </small>
        <small class="text-muted" *ngIf="uploadState.pendingCount > 0">
          <i class="pi pi-clock"></i> {{ uploadState.pendingCount }} Pending
        </small>
      </div>
    </div>

    <!-- File List -->
    <div class="files-list">
      <div
        *ngFor="let file of uploadState.files; let i = index"
        class="file-item"
        [class.file-active]="i === uploadState.currentFileIndex"
      >
        <div class="file-header">
          <div class="file-info">
            <i class="pi pi-file-pdf me-2" style="color: #dc3545"></i>
            <div class="file-details">
              <div class="file-name">{{ file.fileName }}</div>
              <div class="file-meta">
                Position {{ file.position }} • {{ file.size }}
              </div>
            </div>
          </div>
          <div class="file-status">
            <i
              [class]="getStatusIcon(file.status)"
              [style.color]="getStatusColor(file.status)"
              [title]="getStatusText(file.status)"
            ></i>
          </div>
        </div>

        <div class="file-progress" *ngIf="file.status !== 'pending'">
          <div class="progress" style="height: 6px">
            <div
              class="progress-bar"
              [class.bg-success]="file.status === 'success'"
              [class.bg-danger]="file.status === 'error'"
              [class.bg-info]="
                file.status === 'uploading' || file.status === 'converting'
              "
              [class.bg-warning]="file.status === 'validating'"
              [class.progress-bar-striped]="
                file.status !== 'success' && file.status !== 'error'
              "
              [class.progress-bar-animated]="
                file.status !== 'success' && file.status !== 'error'
              "
              role="progressbar"
              [style.width.%]="file.progress"
            ></div>
          </div>
          <div class="d-flex justify-content-between mt-1">
            <small class="text-muted">{{ getStatusText(file.status) }}</small>
            <small class="text-muted">{{ file.progress }}%</small>
          </div>
        </div>

        <div
          class="file-error"
          *ngIf="file.status === 'error' && file.errorMessage"
        >
          <div
            class="alert alert-danger py-2 px-3 mb-0 d-flex align-items-center"
          >
            <i
              class="pi pi-exclamation-triangle me-2"
              style="flex-shrink: 0"
            ></i>
            <small>{{ file.errorMessage }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Completion section -->
    <div
      class="completion-section mt-3"
      *ngIf="
        showReviewerForm ||
        apiCallStatus === 'loading' ||
        apiCallStatus === 'success' ||
        apiCallStatus === 'error'
      "
    >
      <!-- Reviewer / Checker form -->
      <div
        class="checker-card"
        *ngIf="showReviewerForm && orderReviewerRequired"
      >
        <div class="checker-card__header">
          <span class="checker-card__icon">
            <i class="pi pi-shield"></i>
          </span>
          <div class="header-lable">
            <p class="mb-0 fw-bold">Approval Required</p>
            <small class="text-muted">
              Assign a checker to approve this order
            </small>
          </div>
        </div>

        <form [formGroup]="reviewerForm" class="checker-card__body">
          <div class="checker-field mb-3">
            <label class="checker-label mb-2">
              Checker <span class="text-danger">*</span>
            </label>
            <app-multiselect-dropdown
             #multiselect
              placeholder="Select Checker"
              [options]="userData"
              formControlName="reviewer"
              optionLabel="first_name"
              (onChange)="onReviewerSelect()"
              appendTo="body"
              scrollHeight="200px"
              [filter]="true"
              panelStyleClass="small-dropdown-panel"
              [baseZIndex]="10001"
              [autoZIndex]="true"
              [style]="{
                'width': '100%',
                'height': '1.7rem',
                'display': 'flex',
                'align-items': 'center',
                'border-radius': '10px',
                'font-size': '0.8rem'
              }"
            ></app-multiselect-dropdown>
            <div
              class="invalid-hint"
              *ngIf="
                reviewerSubmitted &&
                reviewerForm.get('reviewer')?.hasError('required')
              "
            >
              Please select at least one checker.
            </div>
          </div>

          <div formArrayName="reviewEmail" *ngIf="reviewEmailArray.length > 0">
            <label class="checker-label mb-2 d-block">Selected Reviewers</label>
            <div class="reviewer-chips">
              <div
                class="reviewer-chip"
                *ngFor="let ctrl of reviewEmailArray.controls; let idx = index"
                [formGroupName]="idx"
              >
                <span class="chip-avatar">
                  <i class="pi pi-user"></i>
                </span>
                <span class="chip-email">{{ ctrl.get("email")?.value }}</span>
                <button
                  type="button"
                  class="chip-remove"
                  (click)="removeReviewer(idx)"
                  title="Remove"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn btn-primary w-100 mt-1 submit-checker-btn"
            (click)="submitReviewer()"
          >
            <i class="pi pi-send me-2"></i>
            Submit Order for Approval
          </button>
        </form>
      </div>

      <!-- Loading -->
      <div class="alert alert-info mb-0" *ngIf="apiCallStatus === 'loading'">
        <div class="d-flex align-items-center">
          <i class="pi pi-spin pi-spinner me-3" style="font-size: 24px"></i>
          <div class="flex-grow-1">
            <strong>Processing Your Order...</strong>
            <div class="mt-1 small">
              Please wait while we process your uploaded files.
            </div>
          </div>
        </div>
      </div>

      <!-- Success: No Reviewer Required -->
      <div
        class="alert alert-success mb-0"
        *ngIf="apiCallStatus === 'success' && !orderReviewerRequired"
      >
        <div class="text-center py-3">
          <div class="success-icon mb-3">
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="40" fill="#28a745" opacity="0.1" />
              <circle cx="40" cy="40" r="32" fill="#28a745" opacity="0.2" />
              <path
                d="M25 40L35 50L55 30"
                stroke="#28a745"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h5 class="mb-2"><strong>Order Successfully Submitted!</strong></h5>
          <p class="mb-0 text-muted">
            Your order is under process. Once complete, you will receive an
            email notification from Doqfy.
          </p>
        </div>
      </div>

      <!-- Success: Sent for Approval -->
      <div
        class="approval-success-card"
        *ngIf="apiCallStatus === 'success' && orderReviewerRequired"
      >
        <div class="approval-success-card__icon">
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="36" cy="36" r="36" fill="#fff3cd" />
            <circle cx="36" cy="36" r="28" fill="#ffc107" opacity="0.25" />
            <circle
              cx="36"
              cy="36"
              r="14"
              stroke="#e6a800"
              stroke-width="2.5"
              fill="none"
            />
            <path
              d="M36 28v8l5 3"
              stroke="#e6a800"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <h5 class="approval-success-card__title">Order Sent for Approval</h5>
        <p class="approval-success-card__subtitle">
          Your order has been successfully submitted and is now
          <strong>awaiting checker approval</strong>.
        </p>
        <div class="approval-success-card__steps">
          <div class="approval-step approval-step--done">
            <span class="approval-step__dot"><i class="pi pi-check"></i></span>
            <span class="approval-step__label">PDFs Uploaded</span>
          </div>
          <div class="approval-step__connector"></div>
          <div class="approval-step approval-step--active">
            <span class="approval-step__dot"><i class="pi pi-user"></i></span>
            <span class="approval-step__label">Checker Review</span>
          </div>
          <div class="approval-step__connector"></div>
          <div class="approval-step approval-step--pending">
            <span class="approval-step__dot">
              <i class="pi pi-file-edit"></i>
            </span>
            <span class="approval-step__label">Order Complete</span>
          </div>
        </div>
        <p class="approval-success-card__note">
          <i class="pi pi-info-circle me-1"></i>
          The assigned checker will review and approve your order. You will be
          notified via email once the order is approved and processed.
        </p>
      </div>

      <!-- Error -->
      <div class="alert alert-danger mb-0" *ngIf="apiCallStatus === 'error'">
        <div class="text-center py-3">
          <div class="error-icon mb-3">
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="40" fill="#dc3545" opacity="0.1" />
              <circle cx="40" cy="40" r="32" fill="#dc3545" opacity="0.2" />
              <path
                d="M30 30L50 50M50 30L30 50"
                stroke="#dc3545"
                stroke-width="4"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <h5 class="mb-2"><strong>Order Submission Failed</strong></h5>
          <p class="mb-3 text-muted small">{{ apiErrorMessage }}</p>
          <button class="btn btn-danger btn-sm" (click)="retryApiCall()">
            <i class="pi pi-refresh me-2"></i> Retry Submission
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="uploadState && uploadState.isActive && !uploadState.isMinimized"
  class="upload-backdrop"
  (click)="toggleMinimize()"
></div>
